import { render, staticRenderFns } from "./EditorMatches.vue?vue&type=template&id=bb2eb398&scoped=true"
import script from "./EditorMatches.vue?vue&type=script&lang=js"
export * from "./EditorMatches.vue?vue&type=script&lang=js"
import style0 from "./EditorMatches.vue?vue&type=style&index=0&id=bb2eb398&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2eb398",
  null
  
)

export default component.exports